import React from 'react'

const SignUp = () => {
  return (
    <h1>
        Sign up
    </h1>
  )
}

export default SignUp